// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__Dp27C","isToastPopUp":"styles_isToastPopUp__PZKdK"};